<template>
    <div>
        <canvas ref="canvas"></canvas>
    </div>
</template>

<script>
    import { Line } from "vue-chartjs";

    export default {
        name: "GEChart",

        extends: Line,

        props: {
            chartData: {
                type: Object,
                required: true
            },
            options: {
                type: Object,
                require: false
            }
        },

        mounted() {
            this.renderChart(this.chartData, this.options);
        },

        watch: {
            chartData() {
                this.renderChart(this.chartData, this.options);
            },
            options() {
                this.renderChart(this.chartData, this.options);
            }
        },
    }
</script>

<style scoped>

</style>